import './js/utils/constants';
import { getFormByFormId } from './js/services/formServices';
/* Modules */
import './js/modules/widget';
import {
    appUrl, appointmentChannelId, isHiddenPoweredBy, isWhitelabel, leadInfo, setAccessToken,
    setAppUrl,
    setAppointmentChannelId,
    setForm,
    setFormId, setIsHiddenOnDesktop, setIsHiddenOnMobile, setIsHiddenPoweredBy, setIsModalPopup, setIsWhitelabel, setLeadInfo, setLeadTextId,
    setPhoneToCall,
    setPicture,
    setPrimaryColor,
    setTooltip,
    sourceParam,
} from './js/utils/variables';
import { loadWidget } from './js/modules/widget';
import { apiClient } from './js/utils/api';
import { params } from './js/modules/events/movePages';
import { APPOINTMENT_CHANNEL_ID, BOOK_APPOINTMENT_PARAM, DESKTOP_SCREEN, ESTIMATE, ESTIMATE_ID_PARAM, EVENT_ID_PARAM, FULL_PAGE, IGNORE_IFRAME, MOBILE_SCREEN, NEW_LEAD_UPLOAD, UPDATE_APPOINTMENT_CHANNEL, UPLOAD_ID_PARAM } from './js/utils/constants';
import { UAParser } from 'ua-parser-js';
import { createLead } from "./js/services/leadServices";
import { addIconLib, createStylesAppointmentLogin, generateLoginAppointmentBooking } from './js/modules/actions/generateLoginAppointmentBooking';
import { inputPhoneUI } from './js/modules/actions/appointmentLoginPhoneCode';
import PopupLibrary from './js/modules/campaign/popup';
import { matchesUrlPatterns } from './js/utils/urlMatcher';
import { t } from './js/utils/i18n';
import { setSelectedLanguage } from './js/utils/variables';

const scripts = document.querySelectorAll('script[data-id="assistant"]');
const selector = scripts[scripts.length - 1];

const url = selector.getAttribute('src').includes('widget.js')
    ? selector
        .getAttribute('src')
        .substring(0, selector.getAttribute('src').length - 10)
    : window.location.origin;

const formId = params('form_id') ? params('form_id') : selector.getAttribute('form');
const widgetModal = selector.getAttribute('data-popup');
const appointmentChannel = params('appointment_channel_id') ? params('appointment_channel_id') : selector.getAttribute('appointment_channel');

setAppUrl(url);
setFormId(formId);
getData();
setIsModalPopup(!!widgetModal);
setAppointmentChannelId(appointmentChannel);

async function getData() {
    // kloudmd.com scheduling preview appends ?kmd_preview=1 and iframes the
    // live practice page. inIframe() is then true, which would paint Instant
    // Actions as a full-page overlay on top of the booking UI. Stay out.
    try {
        if (params('kmd_preview') === '1') return;
        if (window.sessionStorage && sessionStorage.getItem('kmd_preview') === '1') return;
    } catch (e) {}

    // URL filters and backend path-aware resolution only apply when the widget
    // is embedded on a third-party site. Skip on direct loads (assistant page)
    // and inside iframes (dashboard preview).
    const isDirectLoad = window.location.hostname === 'assistant.pilotpractice.com'
        || window.location.hostname === 'assistant.kloudmd.com';
    const isEmbedded = apiClient.inIframe();
    const currentPath = window.location.pathname;
    const pathForApi = (!isDirectLoad && !isEmbedded) ? currentPath : null;

    const form = await getFormByFormId(formId, appointmentChannelId || appointmentChannel, pathForApi);

    // Check if a sibling widget should load on this page instead
    const siblingOverrides = form.data.sibling_overrides || [];
    for (const sibling of siblingOverrides) {
        if (matchesUrlPatterns(currentPath, sibling.show_only_on_urls)) {
            try {
                const siblingForm = await getFormByFormId(sibling.uuid, appointmentChannelId || appointmentChannel);
                setFormId(sibling.uuid);
                setTooltip(siblingForm.data.title_tooltip);
                setPicture(siblingForm.data.picture);
                setIsHiddenOnDesktop(siblingForm?.data?.hide_on_desktop ?? false);
                setIsHiddenOnMobile(siblingForm?.data?.hide_on_mobile ?? false);
                setIsHiddenPoweredBy(siblingForm?.data?.hide_powered_by ?? false);
                setIsWhitelabel(siblingForm?.data?.project?.whitelabel ?? false);
                if (siblingForm.data.popup_campaign) {
                    try {
                        const popup = new PopupLibrary(siblingForm.data.popup_campaign);
                        popup.init();
                    } catch (e) {}
                }
                await initData(siblingForm.data);
                return;
            } catch (e) {
                // If sibling fetch fails, fall through to default widget
            }
        }
    }

    if (!isDirectLoad && !isEmbedded) {
        // If default widget has show_only_on_urls, only render on matching pages
        const showOnlyUrls = form.data.show_only_on_urls;
        const widgetHiddenByShowOnly = Array.isArray(showOnlyUrls) && showOnlyUrls.length > 0 && !matchesUrlPatterns(currentPath, showOnlyUrls);

        // Check if default widget should be hidden on this page
        const hideOnUrls = form.data.hide_widget_on_urls;
        const widgetHiddenByHideOn = Array.isArray(hideOnUrls) && hideOnUrls.length > 0 && matchesUrlPatterns(currentPath, hideOnUrls);

        if (widgetHiddenByShowOnly || widgetHiddenByHideOn) {
            // Widget is hidden on this page, but popup campaigns run independently
            if (form.data.popup_campaign) {
                try {
                    const popup = new PopupLibrary(form.data.popup_campaign);
                    popup.init();
                } catch (e) {
                    // Silently handle popup initialization errors
                }
            }
            return;
        }
    }

    // Normal flow — render default widget
    setTooltip(form.data.title_tooltip);
    setPicture(form.data.picture);
    setIsHiddenOnDesktop(form?.data?.hide_on_desktop ?? false);
    setIsHiddenOnMobile(form?.data?.hide_on_mobile ?? false);
    setIsHiddenPoweredBy(form?.data?.hide_powered_by ?? false);
    setIsWhitelabel(form?.data?.project?.whitelabel ?? false);
    if (form.data.popup_campaign) {
        try {
            const popup = new PopupLibrary(form.data.popup_campaign);
            popup.init();
        } catch (e) {
            // Silently handle popup initialization errors
        }
    }

    await initData(form.data);
}

function listenMessageIframe(event) {
    if (event.data === UPDATE_APPOINTMENT_CHANNEL) {
        const assistantIframeTemp = document.querySelector(
            '.assistant__container .assistant__content--iframe'
        );
        if (assistantIframeTemp) {
            assistantIframeTemp.contentWindow.postMessage(
                UPDATE_APPOINTMENT_CHANNEL,
                '*'
            );
        } else {
            parent.postMessage(UPDATE_APPOINTMENT_CHANNEL, "*");
            document.querySelector('iframe').contentWindow.postMessage(UPDATE_APPOINTMENT_CHANNEL, "*");
        }
    }

}

export async function initData(response) {
    setPrimaryColor(response.color_theme);
    setPhoneToCall(response.project?.business_phone);
    setAccessToken(response.token);

    if (response.default_language) {
        setSelectedLanguage(response.default_language);
    }
    const isStandaloneWidget = window.location.hostname === 'assistant.pilotpractice.com'
        || window.location.hostname === 'assistant.kloudmd.com'
        || apiClient.inIframe();
    if (isStandaloneWidget) {
        document.title = response.title_tooltip || t('book_appointment');
    }

    await createLeadFromImageUploadLink();

    window.addEventListener('message', listenMessageIframe);

    // const parser = new UAParser(window.navigator.userAgent);

    // currently, we don't redirect if in iframe
    // if (parser.getDevice().type === "mobile" && apiClient.inIframe()) {
    //     document.querySelector('body').insertAdjacentHTML('beforeend', "<div style='top:0;left:0;width:100%;height:100%;position:absolute;' id='redirectOverlay'></div>");
    //     document.getElementById('redirectOverlay').addEventListener('click', () => {
    //         top.location.href = window.location.origin + `?form_id=${params('form_id')}&is_open_assistant=true`;
    //     }, { once: true });
    // }

    if ((apiClient.inIframe() && !params(IGNORE_IFRAME)) || ((params(FULL_PAGE) || params(APPOINTMENT_CHANNEL_ID)) && !params(IGNORE_IFRAME))) {
        let landingPageParam = '';
        let fullWidth = !!params(FULL_PAGE) || !!params(APPOINTMENT_CHANNEL_ID);
        let htmlContent = '';
        const staffIdParam = params('staff_id') ? `&staff_id=${params('staff_id')}` : '';
        const procedureIdParam = params('procedure_id') ? `&procedure_id=${params('procedure_id')}` : '';
        if (params(UPLOAD_ID_PARAM)) {
            landingPageParam = `&${UPLOAD_ID_PARAM}=${params(UPLOAD_ID_PARAM)}`;
        } else if (params(EVENT_ID_PARAM)) {
            landingPageParam = `&${EVENT_ID_PARAM}=${params(EVENT_ID_PARAM)}`;
            if (params('signature') && params('expires')) {
                landingPageParam += `&signature=${encodeURIComponent(params('signature'))}&expires=${params('expires')}`;
                if (params('v')) landingPageParam += `&v=${params('v')}`;
            }
        } else if (params(ESTIMATE_ID_PARAM)) {
            landingPageParam = `&${ESTIMATE_ID_PARAM}=${params(ESTIMATE_ID_PARAM)}`;
        }

        if (params(ESTIMATE)) {
            landingPageParam += `&${ESTIMATE}=true`
        }

        if (staffIdParam) {
            landingPageParam += staffIdParam
        }

        if (procedureIdParam) {
            landingPageParam += procedureIdParam
        }

        // Forward contact-prefill params (from marketing handoffs like
        // kloudmd.com/get-started) into the inner assistant iframe, where
        // urlPrefill.js applies them to the consult / verify-info forms.
        ['full_name', 'first_name', 'last_name', 'email'].forEach((p) => {
            if (params(p)) landingPageParam += `&${p}=${encodeURIComponent(params(p))}`;
        });

        if (isStandaloneWidget && params(APPOINTMENT_CHANNEL_ID) && response?.appointment_channel?.appointment_channel_name) {
            document.title = response.appointment_channel.appointment_channel_name;
        }

        if ((params(FULL_PAGE) && params(BOOK_APPOINTMENT_PARAM) && DESKTOP_SCREEN) || ((params(FULL_PAGE) && params('staff_id') && params('procedure_id')) && DESKTOP_SCREEN)) {
            createStylesAppointmentLogin()
            addIconLib()
            setForm(response)
            htmlContent = generateLoginAppointmentBooking(response.project)
            if (document?.querySelector(".wrapper-login")) {
                document?.querySelector(".wrapper-login").remove()
            }
            document.body.insertAdjacentHTML('beforeend', `${htmlContent}`);
            inputPhoneUI()
            if (leadInfo?.id) {
                renderIframeWidget(landingPageParam, fullWidth, true)
            }
        } else {
            renderIframeWidget(landingPageParam, fullWidth, false)
        }

    } else {
        loadWidget();
    }
}

async function createLeadFromImageUploadLink() {
    if (params(NEW_LEAD_UPLOAD)) {
        let newLead = await createLead({
            'first_name': params('first_name'),
            'last_name': params('last_name'),
            'email': params('email'),
            'phone': params('phone')
        });

        setLeadInfo(newLead.data);
        setLeadTextId(newLead.data.text_id);
    }
}

function addCSSStyles(css, id = null) {
    if (id && document.getElementById(id)) {
        return;
    }

    const styleTag = document.createElement('style');
    if (id) {
        styleTag.id = id;
    }
    styleTag.innerHTML = css;
    document.head.append(styleTag);
}

function addIframeResponsiveStyles(isBookingFlow, fullWidth) {
    if (!isBookingFlow) {
        addCSSStyles(`
            .iframe-widget--standard {
                @media only screen and (max-width: 540px) {
                    width: 100% !important;
                }
            }
        `, 'iframe-standard-responsive');
    }

    if (isBookingFlow) {
        addCSSStyles(`
            .iframe-widget--booking {
                @media only screen and (max-width: 600px) {
                    width: 100% !important;
                    height: 100% !important;
                }
            }
        `, 'iframe-booking-responsive');
    }

    if (fullWidth) {
        addCSSStyles(`
            .block__iframe iframe {
                @media only screen and (max-width: 600px) {
                    width: 100%;
                    height: 100%;
                }
            }
        `, 'iframe-fullwidth-legacy');
    }
}

function renderIframeWidget(landingPageParam, fullWidth, isAppointmentWebpage) {
    const isBookAppointmentFlow = (params('staff_id') && params('procedure_id')) || params(APPOINTMENT_CHANNEL_ID)
    const isBookingFlow = (isBookAppointmentFlow && params(FULL_PAGE) || params(APPOINTMENT_CHANNEL_ID)) && !MOBILE_SCREEN
    let companyName = params('appUrl')?.includes('kloudmd')
        ? 'KloudMD'
        : 'PilotPractice';
    let poweredByHtml = (isHiddenPoweredBy || isWhitelabel || apiClient.inIframe())
        ? ''
        : `
        <span class="footer" style="font-size: 14px; color: gray; font-family: Poppins, sans-serif; cursor: pointer;">
            <span>Powered by <b style="margin-left: 3px;"><u class="powered_by">${companyName}</u></b></span>
        </span>
    `;
    let htmlContent = `
    <div style="background-color: #f1f4f6; width: ${
        isAppointmentWebpage ? '100%' : '100vw'
    }; height: ${
        isAppointmentWebpage ? '100%' : '100vh'
    }; display: flex; flex-direction: column; align-items: center; gap: 30px; ${
        isBookingFlow ? '' : 'align-items: center'
    };" class="block__iframe">
        <iframe src="${appUrl}?form_id=${formId}&ignore_iframe=1${landingPageParam}${
        fullWidth ? '&full_page=1' : ''
    }${
        params(APPOINTMENT_CHANNEL_ID)
            ? `&appointment_channel_id=${params(APPOINTMENT_CHANNEL_ID)}`
            : ''
    }" style="border: none; border-radius: 16px; box-shadow: rgb(204 204 204) 0px 0px 8px; ${
        isBookingFlow
            ? 'margin-top: 66px;'
            : 'width: 540px;'
    } " allow="payment *" class="iframe-widget ${isBookingFlow ? 'iframe-widget--booking' : 'iframe-widget--standard'}" ${
        isBookingFlow ? `width="800" height="612"` : `height="612"`
    }></iframe>
        ${poweredByHtml}
    </div >
`;
    addIframeResponsiveStyles(isBookingFlow, fullWidth);

    if (isAppointmentWebpage) {
        document.querySelector(".wrapper-login .container-right").innerHTML = ""
        document.querySelector(".wrapper-login .container-right").insertAdjacentHTML('beforeend', `${htmlContent}`);
    } else {
        document.querySelector('body').style.margin = 0;
        document.body.insertAdjacentHTML('beforeend', `${htmlContent}`);
    }

    if (!isWhitelabel) {
        let url = params('appUrl');
        let companyUrl = url?.includes('kloudmd')
            ? 'https://kloudmd.com'
            : 'https://pilotpractice.com';

        document.querySelectorAll('.footer span').forEach((i) => {
            i.onclick = () => {
                window.parent.parent.location.href = `${companyUrl}${
                    sourceParam ? `?source=${sourceParam}` : ''
                }`;
            };
        });
    }
}
